module.exports = __webpack_public_path__ + "img/product page mockup.d7563901.png";